export const adminTableStyles = {
  table: {
    style: {
      backgroundColor: "transparent",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#f7f3f0",
      borderBottom: "1px solid rgba(209, 213, 219, 0.5)",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      fontSize: "11px",
      fontWeight: "700",
      color: "#757575",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      fontFamily: "Josefin Sans, sans-serif",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      fontFamily: "Josefin Sans, sans-serif",
      color: "#545454",
      backgroundColor: "#FFFEFD",
      minHeight: "52px",
      borderBottom: "1px solid rgba(209, 213, 219, 0.25)",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#f7f3f0",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid rgba(209, 213, 219, 0.5)",
      backgroundColor: "#FFFEFD",
      fontFamily: "Josefin Sans, sans-serif",
      color: "#545454",
    },
  },
  noData: {
    style: {
      fontFamily: "Josefin Sans, sans-serif",
      color: "#757575",
      padding: "48px 16px",
    },
  },
};
